// Helper function to convert UTC date string to client's local date (at midnight local time)
export const getClientLocalDate = (dateString: any): Date | null => {
    if (!dateString) return null;
    
    let date: Date;
    if (typeof dateString === 'string') {
        date = new Date(dateString);
    } else if (dateString instanceof Date) {
        date = dateString;
    } else {
        return null;
    }
    
    // Create a local date using the client's timezone interpretation
    // This converts UTC to client local time, then extracts just the date part
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
};

// Convert UTC date to client-local date string for display
export const formatClientLocalDate = (dateString: any): string => {
    const localDate = getClientLocalDate(dateString);
    return localDate ? localDate.toLocaleDateString() : '';
};
